import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { BlogPost } from './pages/BlogPost';
import { ServiceDetail } from './pages/ServiceDetail';
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <Routes data-id="element-13">
        <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
        <Route path="/blog/:slug" element={<BlogPost data-id="element-17" />} data-id="element-16" />
        <Route path="/services/:slug" element={<ServiceDetail data-id="element-19" />} data-id="element-18" />
      </Routes>
    </BrowserRouter>;
}